(function () {
  "use strict";

  function arproUi(key, fallback, values) {
    var translations = window.arproI18n;
    var template = translations && Object.prototype.hasOwnProperty.call(translations, key) && typeof translations[key] === "string" && translations[key]
      ? translations[key] : fallback;
    return String(template).replace(/\{([A-Za-z][A-Za-z0-9_]*)\}/g, function (match, name) {
      return values && Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match;
    });
  }

  var menuButton = document.querySelector("[data-arpro-menu-toggle]");
  var menu = document.querySelector("[data-arpro-nav]");

  function closeMenu(returnFocus) {
    if (!menuButton || !menu) return;
    menu.dataset.open = "false";
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", arproUi("js_menu_open", "Ouvrir le menu"));
    if (returnFocus) menuButton.focus();
  }

  if (menuButton && menu) {
    menuButton.addEventListener("click", function () {
      var open = menu.dataset.open !== "true";
      menu.dataset.open = String(open);
      menuButton.setAttribute("aria-expanded", String(open));
      menuButton.setAttribute("aria-label", open ? arproUi("js_menu_close", "Fermer le menu") : arproUi("js_menu_open", "Ouvrir le menu"));
      if (open) {
        var firstLink = menu.querySelector("a");
        if (firstLink) firstLink.focus();
      }
    });

    menu.addEventListener("click", function (event) {
      if (event.target.closest("a")) closeMenu();
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMenu(true);
  });

  document.addEventListener("click", function (event) {
    if (!menu || !menuButton || menu.dataset.open !== "true") return;
    if (!menu.contains(event.target) && !menuButton.contains(event.target)) closeMenu();
  });

  document.querySelectorAll("[data-arpro-product-form]").forEach(function (form) {
    var selector = form.querySelector("[data-arpro-variant-select]");
    var quantity = form.querySelector("[data-arpro-quantity]");
    var price = form.closest("[data-arpro-product]")?.querySelector("[data-arpro-product-price]");
    var submit = form.querySelector("[type='submit']");

    if (!selector) return;

    function syncVariant() {
      var option = selector.options[selector.selectedIndex];
      if (!option) return;

      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (quantity) {
        quantity.min = option.dataset.minimum || "1";
        quantity.step = option.dataset.increment || "1";
        if (option.dataset.maximum) {
          quantity.max = option.dataset.maximum;
        } else {
          quantity.removeAttribute("max");
        }
        var current = Number(quantity.value || 0);
        var minimum = Number(quantity.min || 1);
        if (!Number.isFinite(current) || current < minimum) quantity.value = String(minimum);
      }
      if (submit) {
        var available = option.dataset.available === "true";
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldoutLabel;
      }
    }

    selector.addEventListener("change", syncVariant);
    syncVariant();
  });

  document.querySelectorAll("[data-arpro-sort]").forEach(function (select) {
    select.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      window.location.assign(url.toString());
    });
  });
})();
